export default {
  MALE: "M",
  FEMALE: "F",
};
